import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ActiveCardInputsStyle = ({ theme }) => ({
  padding: '24px',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '22px'
});

export const DialogActionsStyle = ({ theme }) => ({
  width: '100%',
  bottom: 0,
  right: 0,
  padding: '16px',
  [theme.breakpoints.up('sm')]: {
    padding: '16px 60px',
    maxWidth: '1450px',
    margin: 'auto'
  }
});

export const Wrapper = styled(Stack)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));

export const DialogContentStyled = styled(DialogContent)(() => ({
  padding: 0,
  '::-webkit-scrollbar': {
    display: 'none'
  }
}));
